import React, {useState, useEffect, useContext} from 'react'

export default function RelevanceScore({relevanceScore,section}) {

  let className = "green_back";
  let isclassName = "green_impact";
  if(relevanceScore < 25){
      className = "red_back"; 
  }else if(relevanceScore >= 25 && relevanceScore < 50){   
    className = "red_back";
  }else if(relevanceScore >= 50 && relevanceScore < 70){    
    className = "orange_back";
  }else if(relevanceScore >= 70){    
    className = "green_back";
  }

  if(section == 'impact_score') {
      if(relevanceScore < 3){
        isclassName = "red_impact"; 
      }else if(relevanceScore >= 3 && relevanceScore < 5){   
        isclassName = "red_impact";
      }else if(relevanceScore >= 5 && relevanceScore < 7){    
        isclassName = "orange_impact";
      }else if(relevanceScore >= 7){ 
        isclassName = "green_impact";
      }
  }
  return (
    <>
      {section === 'opportunities_table' ? (
        <span className={`releavance_score mr-2 ${className}`} >
          {relevanceScore && Math.round(relevanceScore)}%
        </span>
     ) : section === 'overview_bs' ? (
      <span className={`numbers ${className}`} >
        {relevanceScore && Math.round(relevanceScore)}%
      </span>
      ) : section === 'impact_score' ? (
       <p className={`impact_score_text ${isclassName}`}>Impact Score: {" "}
        {relevanceScore}/10
        </p>
      ) : (
        relevanceScore && Math.round(relevanceScore)
      )}
    </>
  );
};